import PageImage1 from '../Images/Testimonials/image_test.97a0ea3c0754314a85f1.jpeg'
import PageImage2 from '../Images/Testimonials/WhatsApp Image 2026-02-13 at 9.00.19 AM.42d61d1176f991eea7c9.jpeg'
import PageImage3 from '../Images/Testimonials/WhatsApp Image 2026-02-13 at 4.05.13 PM.b0511fe98f0da8e0f139.jpeg'

import Header from '../components/header'
import Footer from '../components/footer'

import { HelmetProvider } from 'react-helmet-async';

export default function Testimonial() {
    return (
        <div className="Testimonial-Page" style={{ backgroundColor: '#FFFDF4' }}>
            <HelmetProvider>
                <title>about Us</title>
                <meta name="description" content="About the founders and childen of Sur Saathi a Mumbai-based music initiative offering free choir, rhythm, and performance opportunities for children to build confidence and joy." />
                <link rel="canonical" href="https://sursaathi.in/testimonial" />
            </HelmetProvider>
            <Header />
            <div className="Testimonials-Section">
                <h1 className="Testimonials-Title">Testimonials</h1>
                <div className="Testimonials-List">
                    <div className="Testimonials-Card Testimonials-Card-one">
                        <div className="Testimonials-Card-Text">
                            <h2>Kenrick Drago</h2>
                            <h3>Piano Teacher</h3>
                            <p>
                                What a wonderful initiative! Sur Saathi is doing a tremendous job teaching music to children. By providing a platform for these children to explore their creative side, Sur Saathi is not only imparting musical skills but also spreading joy and confidence. Music has the power to transform lives, and Sur Saathi is making that happen. It's heartening to see such initiatives making a difference.♥️🎶

                            </p>
                            <p>
                                Kudos to Sarthak and all those involved in Sur Saathi – your dedication and passion are truly inspiring. Your selfless efforts help shape young minds and make a real impact on the lives of these children. Keep shining!

                            </p>
                        </div>
                        <div className="Testimonials-Card-Image">
                            <img src={PageImage1}/>
                        </div>
                    </div>
                    <div className="Testimonials-Card Testimonials-Card-two">
                        <div className="Testimonials-Card-Image">
                            <img src={PageImage2}/>
                        </div>
                        <div className="Testimonials-Card-Text">
                            <h2>Tatum</h2>
                            <h3>Vocal Studio By Tatum</h3>
                            <p>
                                It’s amazing when you can take your passion and use it to work towards a cause that’s what these talented young students have done with their initiative at Sur Saathi. They are driven with God-given talents and are sharing it with others who haven’t had the opportunity like them.

                            </p>
                            <p>
                                Through their work, they have not only cultivated musical skills but also instilled confidence and joy in the children they teach, using their gifts to bless others and build a strong community of musicians, singers and artistes.

                            </p>
                        </div>
                    </div>
                    <div className="Testimonials-Card Testimonials-Card-three">
                        <div className="Testimonials-Card-Text">
                            <h2>Gopal Chakravartty</h2>
                            <h3>Violin Teacher</h3>
                            <p>As music teachers, it fills us with deep pride and quiet joy to see students bring Sursathi into the world. To commit themselves to nurturing musical understanding in underprivileged children—week after week—while carrying the weight of demanding academic lives, speaks not only of discipline, but of a rare generosity of spirit. Through music, these children will learn to understand and regulate their emotions, to listen and connect with others, to touch something spiritual and sustaining within themselves, and to explore their creativity with confidence and wonder. The seeds being sown will shape their futures in ways that go far beyond melody and rhythm. And in this act of giving, the students’ own lives will be immeasurably enriched—their musicianship deepened, their compassion expanded, and their journeys made more meaningful. We offer our warmest wishes to all involved in Sursathi: may this shared path be filled with growth, harmony, and lasting success.

                            </p>
                        </div>
                        <div className="Testimonials-Card-Image">
                            <img src={PageImage3}/>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
